<template>
  <div id="capital-filter">
    <button 
      class="ui button"
      :class="{ chosen: capital === chosen, unchosen: capital !== chosen }"
      v-for="(capital, index) in capitals"
      :key="index"
      @click="updateCapital(capital)"
    >
      {{capital}}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chosen: 'All'
    };
  },
  computed: {
    capitals() {
      return ['All'].concat('abcdefghijklmnopqrstuvwxyz'.toUpperCase().split(''));
    }
  },
  methods: {
    updateCapital(capital) {
      this.chosen = capital;
      this.$store.dispatch('updateCapital', capital);
    }
  }
}
</script>

<style>
#capital-filter {
  width: 80%;
  margin: 32px auto 0;
}

#capital-filter button {
  padding: 0;
  height: 32px;
  width: 32px;
  font-size: 1.2rem;
  border-radius: 0;
  margin: 4px 12px;
}

#capital-filter button.chosen {
  background-color: #00ADB5;
  color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}

#capital-filter button.unchosen {
  background-color: white;
  color: #00ADB5;
}

</style>



// WEBPACK FOOTER //
// src/components/CapitalFilter.vue